export enum ModalTypes {
  auth,
  release,
  refill,
  limits,
}

export enum ErrorMessages {
  operation = 'operationLimitReached',
  month = 'monthLimitReached',
}

export type StateByCodeType = {
  isCardNotReleased: boolean;
  isNotEnoughBalance: boolean;
  isLimitReached: boolean;
  isMonthLimitReached: boolean;
  isOperationLimitReached: boolean;
};
